import React, { useEffect, useState } from "react";
import Joyride, { CallBackProps } from "react-joyride";
import { useTheme } from "@mui/material";
import { OnboardingServices, OnboardingState } from "../../shared/services/OnboardingServices";

export const Onboarding: React.FC = () => {
	const theme = useTheme();
	const [state, setState] = useState<OnboardingState>(OnboardingServices.state);

	useEffect(() => {
		// Inscreve-se para mudanças no serviço de onboarding
		const unsubscribe = OnboardingServices.onChange((newState) => {
			setState(newState);
		});
		return () => unsubscribe();
	}, []);

	const handleJoyrideCallback = (data: CallBackProps) => {
		// Repassa os callbacks para o serviço controlar o estado
		OnboardingServices.handleJoyrideCallback(data);
	};

	if (!state.run) {
		return null;
	}

	return (
		<Joyride
			steps={state.steps}
			run={state.run}
			stepIndex={state.stepIndex}
			callback={handleJoyrideCallback}
			continuous={true}
			showProgress={true}
			showSkipButton={true}
			styles={{
				options: {
					zIndex: 10000,
					primaryColor: theme.palette.primary.main,
					textColor: theme.palette.text.primary,
					backgroundColor: theme.palette.background.paper,
					arrowColor: theme.palette.background.paper,
				},
				tooltipContainer: {
					textAlign: "left",
				},
				buttonNext: {
					backgroundColor: theme.palette.primary.main,
				},
				buttonBack: {
					color: theme.palette.text.secondary,
				},
			}}
			locale={{
				back: "Voltar",
				close: "Fechar",
				last: "Concluir",
				next: "Próximo",
				skip: "Pular",
			}}
		/>
	);
};
